/**
 * Depth-state parameters, in the only dialect this renderer speaks.
 *
 * deck.gl 9 sits on luma.gl 9, and in interleaved mode the overlay's default
 * parameters are v9-style (`depthCompare: "less-equal"`, `depthWriteEnabled`).
 * Those defaults are applied to each layer's model PIPELINE state, which wins
 * over the global GL state that legacy v8 keys (`depthTest`, `depthMask`) are
 * routed through — so `parameters: { depthTest: false }` was a no-op, every
 * "annotation" layer silently depth-tested anyway, and flags and permit dots
 * sank into the building extrusions they were told to draw over.
 *
 * Same-key overrides are what actually work: a layer that says
 * `depthCompare: "always"` replaces the default in the parameter merge and
 * lands in the pipeline state. These two objects are the only depth choices
 * this map has; take one, do not write depth keys by hand.
 */

/** Annotation: drawn over whatever is already there, writing no depth. */
export const OVER_EVERYTHING = {
  depthCompare: "always",
  depthWriteEnabled: false,
};

/** A real object in the world: hidden by what stands in front of it. */
export const DEPTH_TESTED = {
  depthCompare: "less-equal",
  depthWriteEnabled: true,
};
